import React from 'react'
import { useNavigate } from 'react-router-dom'

const TermsAndConditions = () => {
  const navigate = useNavigate()

  const handleBackToRetreat = () => {
    navigate('/')
  }

  return (
    <div className="terms-page">
      {/* Header */}
      <header className="terms-header">
        <div className="container">
          <div className="header-content">
            <button 
              className="back-btn"
              onClick={handleBackToRetreat}
            >
              <i className="fas fa-arrow-left"></i>
              Back to Retreat
            </button>
            <h1>Terms & Conditions</h1>
            <p className="header-subtitle">Consciousness Upgrade 2.0 Retreat</p>
          </div>
        </div>
      </header>

      {/* Terms Content */}
      <section className="terms-content">
        <div className="container">
          <div className="terms-wrapper">
            <div className="terms-intro">
              <p>
                By participating in this retreat, you acknowledge that you have read, understood, 
                and agree to the following terms and conditions. Please review them carefully.
              </p>
            </div>

            <div className="terms-section">
              <h2>1. Participation & Conduct</h2>
              <p>
                Participation is fully voluntary. You may step back from activities at any time. 
                Respect for others, facilitators, and the space is required. Disruptive behavior, 
                unapproved substances, or alcohol are not permitted.
              </p>
            </div>

            <div className="terms-section">
              <h2>2. Safety & Property Rules</h2>
              <p>
                You agree to remain on the property during ceremony nights. For safety, phones and 
                car keys will be collected before each evening ceremony and returned the following 
                morning to ensure no one drives or leaves the property in an altered state.
              </p>
            </div>

            <div className="terms-section">
              <h2>3. Health Disclosure</h2>
              <p>
                You affirm that you are 21+, not pregnant or nursing, have disclosed relevant mental 
                or physical health conditions, and are not taking contraindicated medications 
                (SSRIs, MAOIs, antipsychotics).
              </p>
            </div>

            <div className="terms-section">
              <h2>4. Confidentiality & Privacy</h2>
              <p>
                You agree to keep confidential any personal stories or information shared by other 
                participants. Occasional photos or videos may be taken for documentation or future 
                retreat promotion. Your participation in media is optional — you are free to decline 
                at any time.
              </p>
            </div>

            <div className="terms-section">
              <h2>5. Payments & Cancellations</h2>
              <ul className="cancellation-policy">
                <li>
                  <strong>Full Refund:</strong> Cancel at least 48 hours before the retreat start time.
                </li>
                <li>
                  <strong>Partial Refund:</strong> Cancel within 48 hours and receive 50% back or apply 
                  the full balance as credit toward a future retreat.
                </li>
              </ul>
            </div>

            <div className="terms-section">
              <h2>6. Governing Law</h2>
              <p>
                These Terms & Conditions are governed by the laws of California.
              </p>
            </div>

            <div className="terms-acknowledgment">
              <p className="acknowledgment-text">
                <strong>By attending, you confirm you have read, understood, and agree to these Terms & Conditions.</strong>
              </p>
            </div>

            {/* <div className="terms-actions">
              <button 
                className="btn btn-primary btn-large"
                onClick={handleBackToRetreat}
              >
                <i className="fas fa-calendar-plus"></i>
                Return to Retreat Booking
              </button>
            </div> */}
          </div>
        </div>
      </section>
    </div>
  )
}

export default TermsAndConditions
